import { Route, Switch } from 'react-router-dom'
import React from 'react'
import PropTypes from 'prop-types'
import asyncComponent from '../../utils/AsyncComponent'

const AsyncNotFound = asyncComponent(() => import('../NotFound'))

function SwitchOr404 ({ children, ...otherProps }) {
  return (
    <Switch {...otherProps}>
      {children}
      <Route component={AsyncNotFound}/>
    </Switch>
  )
}

SwitchOr404.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}
export default SwitchOr404
